import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../../../services/proto/core/loginProps';
import {onboardingSessions} from './api_session';
import {closeSession, getForm, getSubForm, handleMessage, requestHTML, saveRecord} from './general';
import {isRTL} from '../../../../Localization';
import {getFieldValue} from '../../screens/Questionnaire/utils';
import {endForm} from '../../../../services/form/form';

export const getQuestionCategories = async () => {
    try {
        const formName = 'ONBOARDINGSUBCAT';
        const {form, cols} = await getForm(formName);

        const catsResult = await wcfclient.recordsFetch(
            new priority.netitems.form.FetchRq({
                Session: form.Session,
                Properties: getAdditionalProps(),
                Filters: [
                    {
                        Condition: [
                            {
                                ColumnID: cols.Columns.find(c => c.Name === 'SUBCATENAME')?.ID,
                                Operator: priority.netitems.shared.ComparisonOperator.Eq,
                                Values: ['*']
                            }
                        ]
                    }
                ]
            })
        );

        handleMessage(catsResult.Messages, form.Session);

        const closeSessionRes = await closeSession(form.Session, formName);

        handleMessage(closeSessionRes.Messages, form.Session);

        return catsResult;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export async function getCategories() {
    const res = await getQuestionCategories();

    return res.Records.map(record => {
        const colNameId = isRTL() ? 1 : 2;
        const catName = record.Fields.find(item => item.ColumnID === colNameId);
        const catID = record.Fields.find(item => item.ColumnID === 2);

        return {
            catID: getFieldValue(catID),
            catName: getFieldValue(catName)
        };
    });
}

export const getQuestionDescription = async (form, cols, Keys) => {
    try {
        const subFormName = isRTL() ? 'ONBOARDINGTEXT' : 'ONBOARDINGTEXTENG';
        const form = await wcfclient.start(
            new priority.netitems.form.StartRq({
                Fname: 'ONBOARDINGLINESONE',
                Properties: getAdditionalProps()
            })
        );

        await getSubForm(form.Session, Keys, subFormName);

        const htmlRes = await requestHTML(form.Session);
        await endForm(form.Session);

        return htmlRes.Content;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export const updateQuestion = async ({Session, ScrLine, ColumnID, Value, Keys}) => {
    try {
        const recordEditResponse = await wcfclient.recordEdit(
            new priority.netitems.form.RecordEditRq({
                Session,
                Properties: getAdditionalProps(),
                Keys,
                ScrLine
            })
        );

        handleMessage(recordEditResponse.Messages, Session);

        await wcfclient.fieldUpdate(
            new priority.netitems.form.FieldUpdateRq({
                Session,
                Properties: getAdditionalProps(),
                Field: {ColumnID, Value}
            })
        );

        const saveResponse = await saveRecord(Session);

        return saveResponse;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export const finishQuiz = async () => {
    const formName = 'ONBOARDINGCAT';
    try {
        const {form, cols} = await getForm(formName);

        const ColumnID = cols.Columns.find(c => c.Name === 'CATENAME')?.ID || null;

        const catsResult = await wcfclient.recordsFetch(
            new priority.netitems.form.FetchRq({
                Session: form.Session,
                Properties: getAdditionalProps(),
                Filters: [
                    {
                        Condition: [
                            {
                                ColumnID,
                                Operator: priority.netitems.shared.ComparisonOperator.Eq,
                                Values: ['Onboarding Zoom IL']
                            }
                        ]
                    }
                ]
            })
        );

        handleMessage(catsResult.Messages, form.Session);

        const record = catsResult.Records[0];

        if (record) {
            const Keys = cols.Columns.filter(col => col.Key).map(col => {
                return record?.Fields?.find(f => Number(f.ColumnID) === Number(col.ID)) || {};
            });

            const recordEditResponse = await wcfclient.recordEdit(
                new priority.netitems.form.RecordEditRq({
                    Session: form.Session,
                    Properties: getAdditionalProps(),
                    Keys
                })
            );

            handleMessage(recordEditResponse.Messages, form.Session);

            const fieldUpdateResponse = await wcfclient.fieldUpdate(
                new priority.netitems.form.FieldUpdateRq({
                    Session: form.Session,
                    Properties: getAdditionalProps(),
                    Field: {
                        ColumnID: cols.Columns.find(c => c.Name === 'APPLYONBOARDING')?.ID,
                        Value: {Boolean: true}
                    }
                })
            );

            handleMessage(fieldUpdateResponse.Messages, form.Session);

            await saveRecord(form.Session);
        }

        await closeSession(form.Session, formName);

        return catsResult;
    } catch (e) {
        onboardingSessions.removeFormByKey(formName);
        throw new Error((e as Error).message);
    }
};
